module.exports = __webpack_public_path__ + "static/media/gts09.a414a768.png";